import styled, { createGlobalStyle, css } from 'styled-components';

// Thanks
export const FormThanks = styled.div`
  text-align: center;
`;

// Fast Action Sign Up Modal
export const GlobalFastActionSignUpModalStyles = createGlobalStyle`
  html.has-overlay {
    overflow-y: auto !important;
  }
  #fastaction-signup {
    display: none !important;
  }
`;

export const Wrapper = styled.div<{
  maxWidth?: number;
  padded?: boolean;
}>`
  font-weight: 700;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: ${props => (props.maxWidth ? `${props.maxWidth}px` : 'none')};
  margin: 0 auto;
  margin-top: -0.75rem;
  margin-bottom: 2.25rem;
  ${props =>
    props.padded &&
    css`
      padding-left: var(--form-side-padding);
      padding-right: var(--form-side-padding);
    `}
  
  .Select-menu {
    overflow: scroll !important;
  }
  
  #double-donation-header {
    font-family: var(--font-tertiary);
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }
  
  #double-donation-lede {
    margin-bottom: 1.5rem;  
    font-size: 1.1rem;
    font-weight: 800;
  }

  #double-donation-link {
    font-family: var(--font-tertiary);
    font-weight: 300;
    color: var(--color-neutral-600) !important;
    text-decoration: none;
    border-bottom: 2px solid var(--color-primary-300);
    background-color 0.2s ease-in-out;
    margin-top: -1rem;

    &:hover {
      background-color: var(--color-primary-300) !important;
    }
  }

  #dd-container {
    .search-title {
      font-size: 0.95rem;
      font-weight: 800;
      text-transform: uppercase;
      font-family: var(--font-secondary);
    }
    .dtd-lets-check {
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .cell {
        width: 100%;
      }
      &:after {
        border: none !important;
      }
    }
    .medium-4 {
      width: 0;
      button {
        text-transform: uppercase;
        background-color: var(--color-primary-500) !important;
        border: none;
        border-radius: 0rem;
        font-family: var(--font-secondary);
        font-weight: 700;
        color: var(--color-white) !important;
        border: none;
        font-size: 15px;
        position: relative;
        display: inline-block;
        padding: 20px;
        overflow: visible !important;

        &:hover {
          background-color: var(--color-primary-700) !important;
          color: white !important;
          background-color 0.2s ease-in-out;
        }

        &:after {
          content: '';
          position: absolute;
          right: 0;
          bottom: 0;
          border-bottom: 1.5rem solid var(--color-theme-dark);
          border-left: 1.5rem solid transparent;
          transition: all 0.2s ease-in-out 0s;
        }
      }
    }
    .dtd-callout {
      background-color: var(--color-neutral-200) !important;
      box-shadow: none;
    }
    details {
      border-radius: 0;
    }
    .mg-forms-button {
      font-family: var(--font-tertiary);
      color: var(--color-neutral-600) !important;
      text-decoration: none;
      border-bottom: 2px solid var(--color-primary-300);
      background-color 0.2s ease-in-out;

      &:hover {
        background-color: var(--color-primary-300) !important;
      }
    }
    em {
      font-family: var(--font-tertiary);
      font-style: normal;
    }
    strong {
      font-size: 0.95rem;
      text-transform: uppercase;
      font-family: var(--font-secondary);
      background-color: var(--color-secondary-300) !important;
      padding: 0.2rem;
    }
    .dtd-callout {
      color: var(--color-neutral-600) !important;
      font-weight: 300;
      font-family: var(--font-primary);
    }
    & input {
      color: var(--color-neutral-600) !important;
    }
    .dtd-green {
      font-weight: 800;
      color: var(--color-neutral-600) !important;
      font-size: 0.95rem;
      text-transform: uppercase;
      font-family: var(--font-secondary);
      background-color: var(--color-secondary-300) !important;
      padding: 0.2rem;
    }
    .dtd-footer {
      font-family: var(--font-tertiary);
      color: var(--color-neutral-600) !important;
      .mg-forms-button {
        font-weight: 300;
        color: var(--color-neutral-600) !important;
        text-decoration: none;
        border-bottom: 2px solid var(--color-primary-300);
        background-color 0.2s ease-in-out;

        &:hover {
          background-color: var(--color-primary-300) !important;
        }
      }
    }
    .grid-x {
      .medium-12 {
        &:after {
          content: '';
          position: absolute;
          z-index: 5;
          right: 0;
          bottom: 0;
          border-bottom: 1.5rem solid var(--color-theme-dark);
          border-left: 1.5rem solid transparent;
          transition: all 0.2s ease-in-out 0s;
        }
      }
      position: relative;
      margin-bottom: 1rem;
      .mg-forms-button {
        background-color: var(--color-primary-500) !important;
        border: none;
        border-radius: 0rem;
        font-family: var(--font-secondary);
        font-weight: 700;
        color: var(--color-white) !important;
        border: none;
        font-size: 15px;
        position: relative;
        display: block !important;
        padding: 20px;
        overflow: visible !important;
        margin-bottom: 0;

        &:hover {
          background-color: var(--color-primary-700) !important;
          color: white !important;
          background-color 0.2s ease-in-out;
        }
      }
    }
  }
`;
